'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ERROR } from '../../../consts';
import { PRICE_SUBSCRIPTION } from '../../../app/CardAnnouncement/actionTypes';
import { savePriceSubscriptionForm, hidePriceSubscriptionForm } from '../../../app/CardAnnouncement/actions';

class PriceSubscriptionForm extends Component {
  constructor (props) {
    super(props);

    this.userEmail = props.user.getIn(['data', 'email'], '') || '';

    this.state = {
      email: this.userEmail,
      notify: false,
      errors: []
    };

    this.hidePriceSubscriptionForm = props.hidePriceSubscriptionForm.bind(this);
    this.savePriceSubscriptionForm = props.savePriceSubscriptionForm.bind(this);

    this.handlerClose = this.handlerClose.bind(this);
    this.handlerChangeEmail = this.handlerChangeEmail.bind(this);
    this.handlerSaveSubscription = this.handlerSaveSubscription.bind(this);

    this.clearErrors = () => this.setState({errors: []});
  }

  handlerClose (e) {
    e.preventDefault();
    e.stopPropagation();
    this.hidePriceSubscriptionForm();
  }

  handlerChangeEmail (e) {
    const email = e.target.value;
    this.setState({
      email
    });

    if (email) {
      this.clearErrors();
    }
  }

  handlerSaveSubscription () {
    const email = this.state.email;
    const form = this.props.form;
    const dealType = form.get('dealType');
    const realtyType = form.get('realtyType');
    const realtyId = form.get('realtyId');

    this.clearErrors();

    this.savePriceSubscriptionForm({
      email,
      dealType,
      realtyType,
      realtyId
    })
    .then(action => {
      if (action.type === PRICE_SUBSCRIPTION + ERROR) {
        const errors = action.payload
          ? action.payload.map(err => err.message) : [];

        this.setState({
          errors
        });
      } else {
        this.setState({
          notify: true
        });
      }
    });
  }

  componentWillReceiveProps (nextProps, nextContext) {
    const realtyId = nextProps.form.get('realtyId');
    if (this.props.form.get('realtyId') !== realtyId) {
      this.setState({
        email: this.userEmail,
        notify: false,
        errors: []
      });
    }
  }

  renderNotify () {
    return (
      'Вы успешно подписались. Теперь, при каждом изменении цены, ' +
      'вам на указанный электронный почтовый адрес будут приходить уведомления.'
    );
  }

  renderForm () {
    const isLoading = this.props.form.get('loading') || false;

    return (
      <div>
        <span className='info'>
          Присылать мне уведомления, если цена на объект изменилась.
        </span>

        <div className={'email-box' + (this.state.email_error ? ' error' : '')}>
          <input
            type='email'
            className='text-base'
            value={this.state.email}
            placeholder='Введите ваш email'
            onChange={this.handlerChangeEmail}
          />

          { this.state.errors.map(err => (<span className='error-message'>{err}</span>)) }
        </div>

        <div className='controls'>
          {
            isLoading ? (
              <span>сохранение подписки ...</span>
            ) : (
              <button
                type='button'
                disabled={!this.state.email.length}
                onClick={this.handlerSaveSubscription}
                className='btn btn-primary'
              >
                ПОДПИСАТЬСЯ
              </button>
            )
          }
        </div>
      </div>
    );
  }

  render () {
    const form = this.props.form;
    const isOpen = form.get('open') || false;
    const isNotify = this.state.notify;
    const className = 'form-container form' +
      (this.state.errors.length ? ' error' : '') +
      (isNotify ? ' disable-control' : '');

    return (
      <div className={'modal full-screen' + (isOpen ? ' open fade in' : '')}>
        {
          isOpen && (
            <div className='modal-dialog full-screen'>
              <div className='modal-content animate-top'>
                <div className='modal-box price-subscription-modal'>
                  <button type='button' className='close' onClick={this.handlerClose}>×</button>

                  <div className={className}>
                    <h2 className='header'>Подписаться на изменение цены</h2>

                    { isNotify ? this.renderNotify() : this.renderForm() }
                  </div>

                </div>
              </div>
            </div>
          )
        }
        <TransitionGroup>
          {
            isOpen &&
            <CSSTransition key={'modal-backdrop'} appear classNames='fade' timeout={300}>
              <div className='modal-backdrop full-screen' />
            </CSSTransition>
          }
        </TransitionGroup>
      </div>
    );
  }
}

PriceSubscriptionForm.propTypes = {
  form: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  hidePriceSubscriptionForm: PropTypes.func.isRequired,
  savePriceSubscriptionForm: PropTypes.func.isRequired,
};

PriceSubscriptionForm.defaultProps = {};

function mapStateToProps (state) {
  return {
    form: state.getIn(['announcement', 'formPriceSubscription']),
    user: state.get('user')
  };
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    hidePriceSubscriptionForm,
    savePriceSubscriptionForm
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PriceSubscriptionForm);



// WEBPACK FOOTER //
// ./src/ui/Controls/Subscriptions/PriceSubscriptionForm.jsx